<div class="flex flex-col gap-4 mt-4">
  <div>
    <ui-skeleton class="inline-block h-3.5 w-50 rounded-full" />
    <ui-skeleton class="inline-block h-5 w-full rounded-md" />
  </div>

  <div>
    <ui-skeleton class="inline-block h-3.5 w-50 rounded-full" />
    <ui-skeleton class="inline-block h-5 w-full rounded-md" />
  </div>

  <div class="flex items-center gap-2">
    <ui-skeleton class="inline-block h-3.5 w-40 rounded-full" />
    <hr class="flex-1 border-outline dark:border-outline-darkmode" />
  </div>

  <div>
    <ui-skeleton class="inline-block h-3.5 w-50 rounded-full" />
    <ui-skeleton class="inline-block h-5 w-full rounded-md" />
  </div>

  <div>
    <ui-skeleton class="inline-block h-3.5 w-50 rounded-full" />
    <ui-skeleton class="inline-block h-5 w-full rounded-md" />
  </div>

  <div>
    <ui-skeleton class="inline-block h-3.5 w-50 rounded-full" />
    <ui-skeleton class="inline-block h-5 w-full rounded-md" />
  </div>

  <div>
    <ui-skeleton class="inline-block h-3.5 w-50 rounded-full" />
    <ui-skeleton class="inline-block h-5 w-full rounded-md" />
  </div>
</div>
